import { addLocaleData } from "react-intl";
import fr from "react-intl/locale-data/fr";

addLocaleData([...fr]);

/*
Before adding new keys here, add a key mapping in the keys.json file in this directory for
intel and abstraction purposes.
*/
const messages = {
  // PRESCRIBER DASHBOARD
  platform_fees: "Frais de service",
  prices: "Tarifs",
  onboarding: "Enregistrement",
  payments: "Paiements",
  bundle: "Forfait",
  value: "Valeur",
  standard_value: "Valeur facturée par SAYN",
  your_fee: "Vos honoraires",
  custom_value: "Montant à recevoir",
  customer_price: "Prix client",
  customer_value: "Montant facturé au client",
  fee: "Frais",
  sayn_fee: "Frais de service SAYN",
  final_price: "Tarif final",
  onboarding_welcome: "Bienvenue sur votre Tableau de Bord Sayn !",
  onboarding_welcome_message:
    "Afin de pouvoir envoyer des Prescriptions, veuillez compléter votre enregistrement sur Stripe.",
  onboarding_welcome_button: "S'inscrire sur Stripe",
  onboarding_success_title: "Enregistrement terminé avec succès !",
  onboarding_success_subtitle:
    "Votre compte Stripe est actif et prêt à recevoir des paiements.",
  onboarding_success_message:
    "Avant d'envoyer des Prescriptions, veuillez aller à la page de Paiements. Vous pourrez y indiquer votre/vos tarif(s)",
  onboarding_waiting_for_fees:
    "Stripe est actif. Veuillez attendre que le propriétaire définisse les tarifs sur la page Paiements.",
    onboarding_reload_message: "Vous êtes maintenant prêt à envoyer des Prescriptions. Veuillez recharger la page.",
  onboarding_no_account: "Aucun compte Stripe trouvé pour cet utilisateur.",
  onboarding_redirecting: "Redirection vers Stripe...",
  onboarding_error:
    "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard ou contactez le support.",
  onboarding_error_title: "Erreur !",
  onboarding_redirected: "Redirigé vers Stripe.",
  onboarding_need_info: "Informations supplémentaires requises",
  onboarding_need_info_message:
    "Stripe nécessite des informations supplémentaires pour maintenir vos paiements actifs. Veuillez mettre à jour vos informations pour continuer à envoyer des Prescriptions.",
  onboarding_need_info_button: "Mettre à jour les informations Stripe",
  go_to_payments: "Aller à la page de Paiements",
  stripe_registered: "Enregistré sur Stripe",
  prescriber_price_save_alert: "Tarif prescripteur enregistré",
  notice: "Avis",
  payments_currency_conversion_notice:
    "Si un client paie dans une devise autre que l'Euro (€), Stripe appliquera des frais de conversion.",
  prescriber_stripe_account_message:
    "Entrez dans votre compte Stripe Express pour accéder à votre solde, vos transactions, ainsi que pour modifier les paramètres d'e-mail, de numéro de téléphone ou d’informations bancaires",
  go_to_stripe: "Aller vers Stripe",
  my_stripe_account: "Mon compte Stripe",
  allowed_invitations: "Invitations autorisées",
  select_single_reports: "Sélectionner un seul rapport",
  bundle_reports: "Forfait Sayn 1 et Sayn 2",
  best_price: "Meilleur prix",
  select_one_report: "Sélectionner un seul rapport",
  select_one_report_description:
    "Attention, les rapports Sayn 1 et Sayn 2 sont tous deux nécessaires pour bénéficier d’une lecture globale",
  go_to_home: "Aller à l'accueil",
  reload_page: "Recharger la page",
  close: "Fermer",
  close_dialog: "Fermer la fenêtre",
  refresh_monitor: "Actualiser le moniteur",
  no_prescriptions_yet:
    'Aucune prescription pour le moment. Cliquez sur « {prescribe_button} » pour commencer à envoyer des prescriptions.',
  prepayment_draft_leave_warning:
    "Le paiement n'est pas terminé. Quitter supprimera ce brouillon de prescription.",
  success: "Succès",
  full_name: "Nom complet",
  report_edit_sensorial_rhythm: "Rythme Sensoriel",
  report_edit_personal: "Personnel",
  report_edit_individual: "Individuel",
  report_edit_social: "Social",
  report_edit_organizational: "Organisationnel",
  click_select_image: "Cliquez ici pour sélectionner l'Image",
  report_structure_saved: "Le rapport a été enregistré avec succès",
  page_content: "Contenu de la page",
  report_edit_personalIdentity: "Identité personnelle",
  report_edit_internalPerception: "Perception interne",
  report_edit_informationProcessing: "Traitement de l'information",
  report_edit_passingOfHabits: "Transmission des habitudes",
  report_edit_functionalEfficiency: "Efficacité fonctionnelle",
  report_edit_other_graphs: "Autres graphiques",
  reactivity: "Réactivité",
  "429_title": "Trop de requêtes",
  "429_message": "Vous avez effectué trop de requêtes. Veuillez réessayer plus tard.",
  invitation_remote: "Invitation Prépayé",
  invitation_remote_self: "Invitation Prépayé (Soi-même)",
  remote_invite_message: "À qui voulez-vous envoyer l'invitation?",
  remote_invite_option_1_title: "Pour Moi-même",
  remote_invite_option_1_subtitle: "Accès direct",
  remote_invite_option_2_title: "Pour Quelqu'un d'Autre",
  remote_invite_option_2_subtitle: "Cadeau envoyé par email",
  remote_invite_details_1: "Vos coordonnées",
  remote_invite_placeholder_self_name: "Entrez votre nom complet",
  remote_invite_placeholder_self_first_name: "Votre prénom",
  remote_invite_placeholder_self_surname: "Votre nom",
  remote_invite_placeholder_self_email: "Entrez votre email",
  remote_invite_details_2: "Personne invitée",
  remote_invite_placeholder_first_name: "Entrez le prénom de la personne invitée",
  remote_invite_placeholder_surname: "Entrez le nom de famille de la personne invitée",
  remote_invite_placeholder_email: "Entrez l'email de la personne invitée",
  direct_access: "Accès direct",
  remote_invite_self_subtitle: "Pour Moi-même",
  remote_invite_subtitle: "Pour Quelqu'un d'Autre",
  remote_invite_success_title: "Invitation envoyée avec succès",
  remote_invite_success_subtitle:
    "La personne invitée recevra un email pour continuer le processus.\nMerci.",
  remote_invite_self_success_title: "Demande effectuée avec succès",
  remote_invite_self_success_subtitle:
    "Vous recevrez un email pour continuer le processus.\nMerci.",
  invite_blocked_title: "Invitation bloquée",
  invite_blocked_answered_subtitle:
    "Ce patient a répondu à un Questionnaire le {date}. Veuillez attendre jusqu'au {expiry} avant d'envoyer une autre prescription.",
  invite_blocked_pending_subtitle:
    "Ce patient a un Questionnaire en attente depuis le {date}. Veuillez attendre jusqu'au {expiry} avant d'envoyer une autre prescription ou trouvez la prescription en attente dans votre Moniteur et cliquez sur \"{resend_button}\".",
  remote_invite_blocked_title: "Invitation bloquée",
  remote_invite_blocked_answered_subtitle:
    "Vous avez répondu à un questionnaire le {date}. Veuillez attendre jusqu'au {expiry} avant de demander une nouvelle invitation.",
  remote_invite_other_blocked_answered_subtitle:
    "{name} a répondu à un questionnaire le {date}. Veuillez attendre jusqu'au {expiry} avant d'envoyer une autre invitation.",
  remote_invite_blocked_pending_subtitle:
    "Vous avez un questionnaire en attente depuis le {date}. Veuillez vérifier votre courrier électronique ou attendre jusqu'à {expiry} avant de demander une nouvelle invitation.",
  remote_invite_other_blocked_pending_subtitle:
    "{name} a un questionnaire en attente depuis le {date}. Veuillez attendre jusqu'au {expiry} avant d'envoyer une autre invitation.",
  only: "Seulement",
  finish: "Terminer",
  sayn1_description:
    "Il évalue les réponses de votre corps aux stimuli externes (environnement, relations, travail, etc.) et votre capacité d'équilibre.",
  sayn2_description:
    "Il évalue les fonctions sensorielles internes, la gestion des ressources énergétiques et la capacité de récupération.",
  both_reports_description: "Les Deux Rapports (Sayn 1 et 2)",
  //  PRESCRIBER DASHBOARD
  this_language: "français",
  email: "E-mail",
  unsaved_changes: "Modifications non enregistrées",
  unsaved_changes_message:
    "Êtes-vous sûr de vouloir quitter cette page? Tous les modifications non enrigestrées seront perdus.",
  pdf_load_error: "Erreur lors du chargement du PDF",
  stats_info: "Cette valeur correspond à l'augmentation par rapport au mois précédent",
  no_results_found: "Aucun résultat trouvé",
  not_started: "Pas encore commencé",
  resend_prescription: "Renvoyer la prescription",
  prescription: "Prescription",
  send_results_after_completion:
    "Envoyer les résultats au patient par e-mail après achèvement",
  report_unavailable: "Ce rapport n'est pas disponible",
  report_unavailable_description:
    "Le patient peut le débloquer en suivant le lien disponible dans l'e-mail avec les rapports",
  email_changed: "Modification de l'e-mail",
  push_notifications: "Notifications push",
  new_invitation: "Nouvelle invitation",
  new_report: "Nouveau rapport",
  push_notification_saved: "Notification push enregistrée!",
  send_invite_text: "Voulez-vous renvoyer cette invitation?",
  resend: "Renvoyer",
  invite_success: "L'invitation a été envoyée avec succès!",
  send_results: "Envoyer les résultats",
  send_results_text: "Voulez-vous envoyer les résultats au patient?",
  send_results_success: "Résultats envoyés avec succès!",
  send_reports: "Envoyer les rapports",
  change_chart: "Changer le Graphique",
  choose_report: "Choisissez le Rapport",
  choose_reports: "Choisissez les Rapports",
  report_not_requested: "Ce rapport n'a pas été demandé. Ouvrir l'accès pour {price}€",
  confirmed: "Confirmé",
  email_confirmed_close_tab: "Votre adresse e-mail a été confirmée ! Vous pouvez fermer cet onglet maintenant.",
  email_already_confirmed: "Votre e-mail est déjà confirmé. Vous pouvez vous connecter maintenant.",
  account_deletion_page_title: "Supprimer le compte",
  account_deletion_intro: "Veuillez vérifier les détails de votre compte avant de continuer.",
  account_deletion_warning:
    "Cette action est définitive et ne peut pas être annulée. Une fois supprimé, vous perdrez l'accès à tous vos Rapports.",
  account_deletion_button: "Supprimer mon compte",
  account_deletion_confirm_title: "Supprimer votre compte ?",
  account_deletion_confirm_content:
    "Cette action supprimera définitivement votre compte et vous perdrez l'accès à tous vos Rapports. Cette action est irréversible.",
  account_deletion_confirm_ok: "Oui, supprimer mon compte",
  account_deletion_confirm_cancel: "Annuler",
  account_deletion_success: "Votre compte a été supprimé. Vous pouvez maintenant fermer cette fenêtre.",
  account_deletion_error:
    "Une erreur s'est produite lors de la suppression de votre compte. Veuillez réessayer ou contacter le support.",
  account_deletion_loading: "Chargement de votre compte...",
  account_deleted_label: "Compte supprimé",
  questionnaires: "Questionnaires",
  monitor: "Moniteur",
  company_monitor: "Moniteur {name}",
  subscription: "Souscription",
  pd_completed: "Complété",
  failed: "Échec",
  english_language: "Anglais",
  portuguese_language: "Portugais",
  french_language: "Français",
  back: "Retour",
  log_out: "Quitter",
  error_title: "Une erreur s'est produite",
  error_description:
    "Merci de tenter plus tard. Si le problème persiste, veuillez contacter l'assistance",
  select_reports: "Sélection des Rapports",
  choose_option: "Choisir une option",
  patient_paid: "Payement pour le patient",
  patient_paid_description: "Le patient recevra un e-mail afin de procéder au paiement.",
  pre_paid: "Pré-payement",
  pre_paid_description: "Le règlement sera effectué maintenant.",
  both_reports: "Les Deux Rapports",
  reports_and_payment: "Rapports et paiement",
  prescription_successful: "L'analyse SAYN a bien été prescrite.",
  patient_will_receive_email:
    "Bon travail. Votre patient(e) va recevoir un courriel afin de compléter son questionnaire.\nPour suivre le processus, il suffit de consulter l'Aperçu",
  completed_analysis: "Analyses complétées",
  prescriptions_sent: "Prescriptions envoyées",
  total_patients: "Total Patients",
  overview: "Aperçu",
  dashboard: "Tableau de Bord",
  backoffice: "Backoffice",
  my_profile: "Mon Profil",
  sayn_description:
    "L'Analyse SAYN est la première ressource de diagnostic pouvant décoder l'énergie organique de vos patients pour aider à appliquer et adapter tout traitement, promouvant ainsi un accompagnement efficace et les meilleurs résultats possibles.",
  assistance_email:
    "Si vous avez besoin d'assistance, merci d'envoyer un e-mail à {email}",
  need_help: "Besoin d'aide?",
  check_documentation:
    "Consultez notre guide pour trouver la réponse que vous recherchez.",
  documentation: "Guide Sayn",
  view_results: "Résultats",
  completion: "Achèvement",
  prescription_date: "Date de Prescription",
  prescribe_analysis: "Prescrire une Analyse",
  waiting: "En Attente",
  pd_add_observations: "Observations",
  pd_save: "Sauvegarder",
  search_patient: "Rechercher un Patient",
  search_patient_or_prescriber: "Rechercher un Patient/Prescripteur",
  search_team_member: "Rechercher un membre de l'équipe",
  rows_per_page: "Lignes par Page",
  patients: "Patients",
  patient_information: "Informations du patient",
  new_patient: "Nouveau Patient",
  setup_patient_information: "Compléter le formulaire",
  existing_patient: "Patient Existant",
  select_from_patients: "Sélectionnez sur votre liste",
  complete_information: "Complétez les informations",
  invite_placeholder_first_name: "Entrez le prénom du patient",
  invite_placeholder_last_name: "Entrez le nom du patient",
  invite_placeholder_email: "Entrez l'e-mail du patient",
  enter_notes:
    "Si vous souhaiter personnaliser le message à votre patient et ajouter des remarques, merci de le faire ici",
  sd_next: "Suivant",
  // OTHER
  link_in_button_error: "Impossible d'insérer un lien dans un bouton",
  allow_prescriber: "Autoriser votre prescripteur à voir ce Rapport",
  report_payment_message:
    "Votre paiement a été effectué avec succès! Le rapport sera envoyé à votre adresse e-mail.",
  already_paid: "Ce paiement a déjà été effectué.",
  both: "Les deux",
  paid: "Payé",
  not_paid: "Non payé",
  reports_paid: "Rapports payés",
  report_link: "Rapport (avec lien de paiement)",
  report_both: "Rapport(s)",
  email_change_confirmation: "Confirmation de changement d'email",
  email_change_pending_message:
    "Un e-mail de confirmation a été envoyé à {email}. Votre e-mail de connexion changera après confirmation.",
  email_change_pending_notice: "En attente de confirmation de {email}.",
  email_confirmation_app: "Confirmation d'email pour l'application",
  email_address_changed: "Adresse e-mail modifiée",
  questionnaire_message: "Message initial du questionnaire",
  image_delete: "Êtes-vous sûr de vouloir supprimer cette image?",
  image_delete_error:
    "Cette image ne peut pas être supprimée car elle est utilisée ailleurs ({entity}). Veuillez d'abord la retirer de là si vous voulez la supprimer.",
  question_image: "Question",
  delete_success: "{entity} supprimé avec succès!",
  signup: "Inscription",
  sign_up_prescriber: "Inscription prescripteur",
  owner_assignment: "Attribution du propriétaire",
  owner_signup: "Inscription propriétaire",
  insert_url:
    "Entrez l'URL complète du lien (y compris http:// ou https://) :",
  download: "Télécharger",
  preview: "Aperçu",
  gallery: "Galerie",
  gallery_search_by_name: "Rechercher par nom",
  edit_image_name: "Modifier le nom de l'image",
  buttons: "Boutons",
  variables: "Variables",
  links: "Liens",
  enlarge: "Agrandir",
  add_image: "Ajouter cette image",
  edit_text: "Modifier le Texte",
  custom_texts: "Textes Personnalisés",
  seasonal_reminder: "Rappel Saisonnier",
  prescriber_message: "Message au prescripteur",
  template_error: "Tous les Variables et Boutons dans la liste devraient être utilisés!",
  email_template_saved: "Modèle d'email enregistré",
  custom_text_saved: "Texte Personnalisé enregistré",
  email_subject: "Sujet de l'Email",
  edit_template: "Modifier le Modèle",
  email_templates: "Modèles d'Email",
  template: "Modèle",
  new_pacient: "Nouveau Patient",
  existing_pacient: "Pacient existant",
  not_send: "Ne pas envoyer",
  user_name: "Nom",
  user_surname: "Nom de famille",
  job: "Emploi",
  birth: "Naissance",
  portuguese: "Portugais",
  french: "Français",
  error_prepay_remote:
    "Une erreur s'est produite lors du traitement de votre demande. Veuillez nous contacter directement.",
  default_questionnaire_price: "Prix par défaut pour SAYN1 + SAYN2 (en cents)",
  default_sayn1_price: "Prix par défaut pour SAYN1 (en cents)",
  default_sayn2_price: "Prix par défaut pour SAYN2 (en cents)",
  post_questionnaire_delay: "Délai de post-Questionnaire (en heures)",
  seasonal_reminder_range: "Intervalle de rappel saisonnier (en jours)",
  seasonal_reminder_unsubscribed:
    "Vous avez été désabonné. Vous ne recevrez plus de notifications saisonnières à partir de maintenant.",
  token_expiry: "Durée de session après login (HH:mm)",
  token_expiry_invalid: "Utilisez HH:mm (les heures peuvent dépasser 23, p.ex. 48:00)",
  totp: "Code de l'authentificateur",
  totp_help: "Ouvrez votre application d'authentification et saisissez le code à 6 chiffres de ce compte.",
  session_expired: "Votre session a expiré, veuillez vous reconnecter.",
  session_expired_login: "Se connecter",
  enroll_totp_help:
    "Scannez ce QR code avec votre application d'authentification, puis saisissez le code à 6 chiffres.",
  enroll_totp_manual: "Impossible de scanner ? Saisissez cette clé :",
  enroll_totp_qr_alt: "QR code de l'authentificateur",
  invalid_totp: "Code de l'authentificateur invalide",
  totp_challenge_timeout:
    "Le défi de l'authentificateur a expiré. Veuillez saisir à nouveau votre e-mail et votre mot de passe.",
  keep_me_logged_in: "Rester connecté pendant 90 jours",
  mfa_required: "La vérification de l'authentificateur est requise",
  invalid_firebase_token: "Connexion invalide ou expirée. Veuillez réessayer.",
  invalid_role: "Ce compte ne peut pas se connecter au Backoffice",
  MFA_REQUIRED: "La vérification de l'authentificateur est requise",
  INVALID_FIREBASE_TOKEN: "Connexion invalide ou expirée. Veuillez réessayer.",
  INVALID_ROLE: "Ce compte ne peut pas se connecter au Backoffice",
  backoffice_values: "Valeurs éditables",
  max_observation_size: "La taille maximale de l'observation est de {max} caractères",
  first_graph_observations_unavailable:
    "Les observations ne peuvent pas être ajoutées pour le premier graphique. Veuillez sélectionner un autre graphique pour continuer.",
  add_observations: "Ajouter des Observations",
  observations_saved: "Observations enregistrées!",
  values_saved: "Valeurs enregistrées!",
  block_report: "Empêcher l'envoi du rapport",
  block_prescriber: "Suspendre",
  unblock_prescriber: "Réactiver",
  block_company: "Suspendre",
  unblock_company: "Réactiver",
  blocked: "BLOQUÉE",
  prescriber_access_denied_title: "Accès refusé",
  prescriber_access_denied_message:
    "Votre compte a été suspendu pour des raisons internes. Veuillez contacter le propriétaire de votre équipe si vous pensez qu'il s'agit d'une erreur.",
  owner_access_denied_message:
    "Votre compte a été suspendu pour des raisons internes. Contactez-nous si vous pensez qu'il s'agit d'une erreur.",
  prescriber_no_company_message:
    "Vous devez être rattaché à un cabinet pour accéder à la plateforme. Contactez-nous si vous pensez qu'il s'agit d'une erreur.",
  NO_COMPANY:
    "Vous devez être rattaché à un cabinet pour accéder à la plateforme.",
  report_sent: "Rapport envoyé",
  sent: "Envoyé",
  not_sent: "Non envoyé",
  go_back: "Retour",
  observations: "Observations",
  observations_recommendations: "Observations / Recommandations",
  all_rights_reserved: "Tous droits réservés",
  amplitude: "Amplitude",
  next: "Prochaine",
  loading: "Chargement",
  landing_where_answer: "Où souhaitez-vous répondre au questionnaire ?",
  landing_open_in_app: "Ouvrir dans l'application Sayn",
  landing_continue_in_browser: "Continuer dans le browser",
  landing_loading: "Chargement…",
  landing_redirecting: "Redirection en cours...",
  search: "Chercher",
  reset: "Réinitialiser",
  required: "Obligatoire",
  start: "Début",
  pacient: "Patient",
  prescriber: "Prescripteur",
  no_prescriber: "sans prescripteur",
  notes: "Notes",
  general_definitions: "Définition générale",
  help: "Aidez-moi",
  privacy_policy: "Politique de confidentialité",
  copyright: "copyright © 2019 Sensor",
  date: "Date",
  cancel: "Annuler",
  save: "Enregistrer",
  other: "Autre",
  create: "Créer",
  upload: "Télécharger",
  image_upload_max_size: "L'image doit faire 5 Mo ou moins.",
  image_upload_invalid_type: "Vous ne pouvez téléverser que des fichiers JPG, PNG ou GIF.",
  IMAGE_FILE_TOO_LARGE: "L'image doit faire 5 Mo ou moins.",
  edit: "Modifier",
  are_you_sure: "Êtes-vous sûr?",
  yes: "Oui",
  no: "Non",
  price: "Prix",
  total_price: "Prix Total",
  language: "Langue",
  submit: "Soumettre",
  created_at: "Créé à",
  updated_at: "Mis à jour à",
  read_at: "Lire à",
  view: "Voir",
  delete: "Supprimer",
  delete_image: "Supprimer l'image",
  answerOptions: "Réponses",
  dataBase: "Base de Données",
  ACTIVE: "Actif",
  DISABLED: "Désactivé",
  created_by: "Créé par",
  actions: "Actions",
  answers: "Réponses",
  completed: "Terminé",
  not_completed: "Non terminé",
  questionnaire: "Questionnaire",
  questions: "Questions",
  open: "Ouverte",
  multiple: "Plusieurs",
  text: "Texte",
  closed: "Fermé",
  close_window: "Vous pouvez fermer cette fenêtre maintenant.",
  single: "Unique",
  usersHeader: "Utilisateurs",
  history: "Histoire",
  answerQuestionnaire: "Répondre au questionnaire",
  status: "Statut",
  items: "Articles",
  user: "Utilisateur",
  up: "En haut",
  down: "Vers le bas",
  ok: "D'accord",
  criteria: "Critères",
  criteriaUsage: "Imputations",
  metaSkill: "Méta Compétences",
  principle: "Principes",
  code: "code",
  name: "Nom",
  question: "Question",
  answer: "Répondre",
  all: "Toute",
  meta_competences: "Méta Compétences",
  confirm: "Confirmer",
  return: "Revenir",
  invites: "Invitations",
  invite: "Inviter",
  send: "Envoyer",
  elements: "Éléments",
  attributes: "Attributs",
  energy_flow: "Flux d'énergie",
  sending: "Envoi en cours",
  feelings: "Sentiments",
  organs: "Organes",
  outputs: "Outputs",
  output_metadata: "Métadonnées de Output",
  input_metadata: "Métadonnées d'Entrée",
  metadata_bank: "Banque de Métadonnées",
  metaData: "Métadonnées",
  inputs: "Entrées",
  image_metadata: "Métadonnées d'image",
  image: "Image",
  output_information: "Informations de Output",
  none: "Aucun",
  add_input: "Créer Nouvelle Entrée",
  add_output: "Créer Nouvelle Output",
  input_name: "Nom d'entrée",
  input_content: "Contenu d'Entrée",
  type: "Type",
  output_content: "Contenu de Output",
  output_name: "Nom de Output",
  change_type: "Changer le Type",
  input_information: "Saisir des Informations",
  dowload_excel_users: "Exporter vers Excel",
  excel_users_title: "Liste_Utilisateurs_",
  printPDF: "Imprimer le PDF",
  element_attributes: "Attributs de l'Élément",
  attributes_bank: "Banque d'Attributs",
  sense: "Sens",
  duplicate: "Dupliquer",
  natural_elements: "Éléments Naturels",
  add_natural_element: "Créer Nouvelle Élément Naturel",
  create_new_natural_element: "Créer nouvel Élément Naturel",
  edit_natural_element: "Modifier l'Élément Naturel",
  add_season: "Créer Nouvelle Saison",
  create_new_season: "Créer Nouvelle Saison",
  edit_season: "Modifier la Saison",
  season: "Saison",
  add_character: "Ajouter Nouvelle Caractére",
  create_new_character: "Créer Nouvelle Caractére",
  edit_character: "Modifier la Caractére",
  character: "Caractéres",
  basic_settings: "Paramètres de base",
  security_settings: "Les paramètres de sécurité",
  first_name: "Prénom",
  last_name: "Nom de famille",
  birth_place: "Lieu de naissance",
  job_name: "Nom du travail",
  nationality: "Nationalité",
  gender: "Le sexe",
  birth_date: "Date de naissance",
  old_password: "Ancien mot de passe",
  new_password: "Choisissez un nouveau mot de passe",
  choose_password: "Choisissez un mot de passe",
  password: "Mot de passe",
  confirm_email: "Confirmez l'email",
  confirm_password: "Confirmez le mot de passe",
  change: "Changement",
  profile: "Profil de l'utilisateur",
  male: "Masculin",
  female: "Femelle",
  change_password: "Changer le mot de passe",
  invalid_password: "Mot de passe incorrect",
  password_changed: "Votre mot de passe a été changé",
  required_password: "Veuillez saisir votre mot de passe",
  password_does_not_meet_requirements:
    "Le mot de passe doit contenir au moins 6 caractères, 1 caractère majuscule et 1 caractère numérique",
  match_password: "Les deux mots de passe que vous avez entrés ne correspondent pas!",
  password_recovery: "Récupération de mot de passe",
  password_recovery_msg:
    "Un email a été envoyé avec un lien pour changer votre mot de passe. Verifiez votre boîte de réception.",
  match_email: "Les deux emails que vous avez entrés ne correspondent pas!",
  input_email: "Veuillez saisir votre email!",
  invalid_email: "Email invalide",
  profile_updated: "Profil mis à jour",
  profile_updated_message: "Votre profil a été mis à jour",
  creation_date: "Date de Création",
  no_information: "Aucune Information",
  manage_question_criteria: "Gérer les Critères de la Question",
  logout: "Se déconnecter",
  login: "S'identifier",
  login_success: "Connexion réussie!",
  register: "S'inscrire",
  register_success: "Inscription réussie!",
  auth_questionnaire_msg:
    "Vous serez redirigé vers le Questionnaire. \nVous recevrez un lien dans votre email, au cas où vous voudriez revenir plus tard. \nCliquez sur OK pour continuer.",
  title: "Titre",
  users: "Utilisateurs",
  message: "Message",
  cta_questionnaire: "Répondre au Questionnaire",
  new_notification: "Nouvelle Notification",
  send_notification_to: "Envoyer Une Notification à",
  all_users: "Tous Les Utilisateurs",
  some_users: "Certains Utilisateurs",
  dynamic_keys: "Touches Dynamiques",
  confirm_message_disable: "Souhaitez-vous désactiver",
  confirm_message_enable: "Souhaitez-vous activer",
  confirm_this_male: "cette",
  confirm_this_female: "cette",
  enable: "activer",
  disable: "désactiver",
  answer_option: "Réponse",
  text_answer_placeholder: "Écrivez votre réponse ici",
  one_criteria: "critère",
  one_criteria_usage: "imputation",
  one_meta_skill: "compétence",
  one_principle: "principe",
  resending_invitation: "Renvoi de l'invitation",
  resending_invitation_to: "Renvoi de l'invitation à",
  to_fill_questionnaire: "pour remplir le questionnaire",
  clipboard: "Copier le code d'invitation",
  save_changes: "Sauvegarder les Modifications",
  discard_changes: "Annuler les Modifications",
  mobile_answer_component: "Composants",
  one_mobile_answer_component: "Composant",
  add_mobile_answer_component: "Créer Nouveau Composant",
  create_new_mobile_answer_component: "Créer Nouveau Composant",
  edit_mobile_answer_component: "Modifier le Composant",
  disable_mobile_answer_component: "Désactiver le Composant",
  enable_mobile_answer_component: "Activer le Composant",
  general: "Général",
  algorithm_values: "Valeurs d'Algorithme",
  skill_anchor: "Compétence Levier",
  skill_compensated: "Compétence Compens",
  skill_decompensated: "Compétence Décompens",
  criteria_management: "Gestion des Critères",
  free_in_app: "Gratuit dans l'Application",
  add_criteria: "Ajouter Nouveaux Critères",
  edit_criteria: "Modifier le Critère",
  free: "Gratuit",
  initial_date: "Date initiale",
  expire_date: "Date d'expiration",
  description: "Description",
  entities_assigned: "Entités Attribuées",
  entities: "Entités",
  effect_type: "Type d'effet",
  effect: "Effets",
  create_new_highlight_output: "Créer Nouvelle Highlight Output",
  create_new_highlight_question: "Créer Nouvelle Highlight Question",
  highlight_type: "Type de Highlight",
  create_new_highlight_type: "Créer Nouveau Type de Highlight",
  link_android: "Hyperlien Android",
  link_ios: "Hyperlien IOS",
  mobile_apps: "Applications Mobile",
  text_config: "Config Texte",
  assign_entities: "Attribuer des Entités",
  disable_text_config: "Désactiver configuration du texte",
  enable_text_config: "Activer configuration du texte",
  env: "Variables d'environnement",
  add_env: "Créer Nouvelle Variable d'Environnement",
  daily_challenge: "Challenge Quotidien",
  number_of_inputs: "Nombre d'Inputs",
  min_days_of_interval: "Nombre minimum de jours d'intervalle",
  add_highlight_type: "Ajouter Highlight",
  daily_challenge_saved: "Défi quotidien enregistré",
  create_new_highlight_questionnaire: "Créer Nouvelle Highlight Questionnaire",
  edit_highlight_questionnaire: "Modifier Highlight Questionnaire",
  edit_highlight_question: "Modifier Highlight Question",
  type_image: "IMAGE",
  type_text: "TEXTE",
  edit_question: "Modifier la Question",
  clean_filters: "Réinitialiser Filtres",
  static_string: "Strings Statiques",
  add_static_string: "Créer Nouvelle string statique",
  string_value: "Valuer de String",
  add_feeling: "Créer Nouveau Sentiment",
  edit_feeling: "Modifier Sentiment",
  add_organ: "Créer Nouveau Organe",
  edit_organ: "Modifier Organe",
  input_translation: "S'il vous plaît, entrez toutes les traductions",
  select_answer_type: "Veuillez sélectionner le type de réponse",
  set_criteria_as_free: "Définir les critères comme gratuits",
  remove_criteria_as_free: "Supprimer les critères",
  confirm_set_free: "Souhaitez-vous définir ce critère comme gratuit?",
  confirm_remove_free: "Souhaitez-vous supprimer ce critère?",
  free_criterias: "Critère gratuits",
  confirm_set_question_non_required:
    "Souhaitez-vous définir cette question comme non obligatoire?",
  confirm_set_question_required: "Souhaitez-vous définir cette question comme requis?",
  set_non_required: "Définir la question comme non obligatoire",
  set_required: "Définir la question selon les besoins",
  duplicate_questionnaire: "Le questionnaire a été dupliqué",
  add: "Ajouter",
  update_questionnaire: "Le questionnaire a été mis à jour",
  add_new_app: "Ajouter Nouvelle App",
  translate: "Traduire",
  delete_general_output:
    "Cette Output ne peut pas être supprimée car elle est utilisée dans l'application",
  alternative_report: "Rapport Alternatif",
  edit_static_string: "Modifier Texte Statique",
  edit_rich_text: "Modifier Texte Formaté",
  add_rich_text: "Créer Nouveau Texte Formaté",
  plain_text: "Texte Brut",
  rich_text: "Texte Formaté",
  create_new_answer_option: "Créer Nouvelle Réponse",
  edit_answer_option: "Modifier Réponse",
  relevant: "Pertinent",
  irrelevant: "Non pertinent",
  enable_criteria: "Activer les Critères",
  disable_criteria: "Désactiver les Critères",
  set_criteria_as_relevant: "Définir les critères comme pertinents",
  remove_criteria_as_relevant: "Supprimer les critères comme pertinents",
  confirm_set_relevant: "Souhaitez-vous définir ce critère comme pertinent?",
  confirm_remove_relevant: "Souhaitez-vous supprimer ce critère comme pertinent?",
  relevant_criteria: "Critères Pertinents",
  surname: "Nom de Famille",
  role: "Role",
  create_user: "Créer un utilisateur",
  edit_user: "Modifier utilisateur",
  week: "Semaine",
  sunday: "Dimanche",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  add_week: "Ajouter une semaine",
  general_insights: "Aperçus Généraux",
  resources_of_focus_insights: "Fonctionnalités de Focus Insights",
  act_quiz_call_to_action: "Questionnaire d'appel à l'action",
  general_criteria: "Critères généraux",
  self_criteria: "Critères propres",
  social_criteria: "Critères sociaux",
  professional_criteria: "Critères professionnels",
  report_and_react: "Signaler et réagir",
  heart_re_question: "Question du cœur",
  highlight_schedule: "Planification",
  delete_week: "supprimer la semaine",
  next_question: "Question Suivante",
  previous_question: "Question Précédente",
  done: "Finish Questionnaire",
  answer_saved: "Réponse a été enregistrée",
  import: "Importer",
  export: "Exporter",
  import_data: "Importer des données",
  file_imported: "Fichier exporté",
  data_exported: "Données exportées",
  error_exporting_data: "Erreur lors de l'exportation des données",
  invalid_questionnaire_email:
    "L'email n'est pas correct, veuillez le vérifier à nouveau",
  page_not_found: "Page non trouvée",
  error_general: "Une erreur s'est produite, veuillez réessayer plus tard",
  error_general_public:
    "Une erreur s'est produite. Veuillez réessayer plus tard ou contacter le support via ",
  pay: "Payer",
  payment: "Paiement",
  payment_succeeded: "Paiement réussi!",
  payment_unsuccessful:
    "Votre paiement n'a pas été effectué avec succès. Essayez à nouveau, s'il vous plaît.",
  payment_processing: "Votre paiement est en cours de traitement.",
  pre_pay_invite: "Invitation prépayée",
  error: "Erreur",
  export_data: "Exporter les données",
  invitation: "Invitation",
  disable_invitation: "Désactiver l'invitation",
  enable_invitation: "Activer l'invitation",
  algorithm_config: "Configuration d'algorithme",
  user_evolution: "Évolution des Utilisateurs",
  no_data: "Pas de Données",
  answer_type: "Type de Réponse",
  ADMIN: "Admin",
  CONSULTANT: "Consultant",
  PRESCRIBER: "Prescripteur",
  OWNER: "Propriétaire",
  MANAGER: "Gestionnaire",
  ASSISTANT: "Assistant",
  PACIENT: "Patient",
  prescribers: "Prescripteurs",
  add_prescriber: "Ajouter/Modifier le Prescripteur",
  start_date: "Date de début",
  end_date: "Date de fin",
  field_required: "Champ Obligatoire",
  report: "Rapport",
  type_to_search: "Tapez pour rechercher",
  summary_of_resources: "Synthèse des ressources",
  sensorial_rhythms: "Rythmes Sensoriels",
  select_date: "Sélectionner une date",
  confirm_invitation: "Êtes-vous sûr de vouloir envoyer cette invitation?",
  confirm_answer: "Êtes-vous sûr de vouloir continuer?",
  confirm_prepayment: "Êtes-vous sûr de vouloir prépayer cette questionnaire?",
  free_invite: "Sélectionnez cette option pour rendre le questionnaire gratuit",
  sending_email_to: "Envoi d'un email à",
  sending_email: "Envoi d'un email...",
  to_fill_the_questionnaire: "pour remplir le questionnaire",
  sending_invitation: "Envoi d'une invitation",
  invitation_sent: "Invitation envoyée",
  an_email_was_sent_to: "Un email a été envoyé à",
  payment_page_title:
    "L'analyse de votre activité sensorielle est essentielle pour prendre soin de votre santé",
  payment_page_list_title:
    "En analysant votre activité sensorielle, vous rendez cela possible:",
  payment_page_list_item_one:
    "un traitement adapté à votre activité physiologique et biologique;",
  payment_page_list_item_two:
    "une adaptation éclairée des recommandations et des prescriptions;",
  payment_page_list_item_three:
    "une réponse organiquement réussie aux soins de santé dont vous avez besoin.",
  payment_taking_longer:
    "La transaction prend plus de temps que prévu. Veuillez patienter pendant que nous la traitons ou revenir ultérieurement.",
  questionnaire_welcome_page_title: "Bienvenue dans votre système sensoriel",
  questionnaire_welcome_page_right_paragraph_one:
    "À l'instar d'une analyse sanguine, l'analyse SAYN révèle exactement ce que votre corps vous dit manifestement sur lui-même, même si vous n'en êtes pas conscient.",
  questionnaire_welcome_page_right_paragraph_two:
    "En analysant les données et les corrélations de votre organisme biologique, il sera possible à votre professionnel de la santé de comprendre clairement quel soin, quelle prescription ou quelle recommandation est le plus efficace pour vous à l'heure actuelle.",
  questionnaire_welcome_page_right_paragraph_three:
    "Votre activité sensorielle sera analysée à l'aide d'un questionnaire qui prendra environ 15/20 minutes à remplir. Toutefois, vous pouvez prendre autant de temps que vous le souhaitez. Pour une analyse réussie, il est essentiel que vous ayez ce temps pour vous.",
  questionnaire_welcome_page_right_list_title:
    "Avant de commencer, voici ce qu'il faut savoir:",
  questionnaire_welcome_page_right_list_item_one:
    "Répondez de manière absolument libre et intuitive, sans hésitation.",
  questionnaire_welcome_page_right_list_item_two:
    "L'important n'est pas ce qu'ils disent ou ont dit de vous, mais ce que vous ressentez pour vous-même.",
  questionnaire_welcome_page_right_list_item_three:
    "Faites appel à votre candeur et à votre spontanéité pour favoriser une lecture en parfaite adéquation avec votre organisme. Il n'y a pas de bonnes ou de mauvaises réponses.",
  questionnaire_welcome_page_right_list_item_four:
    "Le questionnaire doit être rempli dans son intégralité. Vous ne pouvez pas remplir une partie maintenant et une autre partie plus tard.",
  questionnaire_welcome_page_right_list_item_five:
    "Si vous hésitez sur une réponse, ne vous inquiétez pas, nous vous recommandons de passer simplement à la question suivante.",
  questionnaire_welcome_page_right_footnote:
    "Si vous ne voulez pas continuer maintenant : cliquez sur le lien que vous avez reçu par email pour revenir plus tard. Vous avez 30 jours pour remplir le questionnaire à partir de la date d'inscription.",
  questionnaire_welcome_start_button_text: "Commencer l'analyse",
  questionnaire_completed_page_submitted_text:
    "VOS RÉPONSES ONT ÉTÉ TRANSMISES AVEC SUCCÈS.",
  questionnaire_completed_page_title: "Votre analyse sera bientôt prête",
  questionnaire_completed_page_left_text:
    "Les rapports seront envoyés à votre adresse électronique afin que vous puissiez les partager avec votre professionnel de santé. Pour plus d'informations sur la première analyse qui décode le système sensoriel en temps réel, visitez ",
  questionnaire_completed_page_right_text:
    "Recommandez des soins en parfaite adéquation avec la vraie nature de chaque individu, à commencer avec ceux que vous aimez le plus. Chaque membre ou ami de la famille peut bénéficier de cette analyse afin de s’occuper de sa santé de manière personnalisée.",
  questionnaire_completed_page_right_final: "Recommander SAYN, c'est prendre soin.",
  // BACKEND ERROR MESSAGES
  EMAIL_ALREADY_EXISTS: "Il existe déjà un utilisateur avec cet email",
  EMAIL_NOT_FOUND: "L'email n'a pas été trouvé. Veuillez vérifier à nouveau.",
  ACCESS_DENIED: "Accès refusé",
  USER_DISABLED:
    "Votre compte a été suspendu pour des raisons internes. Veuillez contacter le propriétaire de votre équipe si vous pensez qu'il s'agit d'une erreur.",
  OWNER_DISABLED:
    "Votre compte a été suspendu pour des raisons internes. Contactez-nous si vous pensez qu'il s'agit d'une erreur.",
  USER_NOT_FOUND:
    "Utilisateur non trouvé. \nVeuillez vérifier si l'email est correct ou, alternativement, inscrivez-vous.",
  INVITE_LINK_INVALID: "Ce lien n'est plus valide.",
  team: "Équipe",
  company_team: "{name}",
  company_team_with_country: "{name}, {country}",
  company: "Entreprise",
  companies: "Entreprises",
  country: "Pays",
  owner: "Propriétaire",
  practice_not_set_up:
    "Votre cabinet n'est pas encore configuré. Veuillez attendre que le propriétaire termine l'onboarding.",
  add_team_member: "Ajouter un membre",
  edit_team_member: "Modifier le membre",
  suspend_member: "Suspendre",
  unsuspend_member: "Réactiver",
  remove_member: "Retirer",
  suspend_member_confirm:
    "Suspendre ce membre de l'équipe ? Il ne pourra plus se connecter.",
  unsuspend_member_confirm:
    "Réactiver ce membre de l'équipe afin qu'il puisse se reconnecter ?",
  remove_member_confirm:
    "Retirer ce membre de votre équipe ? Il perdra l'accès à la plateforme.",
  no_team_members: "Aucun membre dans l'équipe pour le moment.",
  team_member_invited: "Invitation envoyée.",
  change_member_role: "Modifier le rôle",
  member_role_updated: "Rôle mis à jour.",
  CANNOT_MANAGE_SELF: "Vous ne pouvez pas modifier votre propre rôle.",
  TEAM_MEMBER_CANNOT_BE_ADDED: "Cet utilisateur ne peut pas être ajouté.",
  USER_ALREADY_HAS_COMPANY:
    "Cet utilisateur appartient déjà à un cabinet et ne peut pas être ajouté à un autre.",
  view_member_insights: "Voir les indicateurs du membre",
  insights: "Indicateurs",
  create_company: "Créer une entreprise",
  edit_company: "Modifier l'entreprise",
  owner_details: "Coordonnées du propriétaire",
  tie_existing_owner_title: "L'utilisateur existe déjà",
  tie_existing_owner_confirm:
    "Un utilisateur avec cet e-mail existe déjà. Voulez-vous le définir comme propriétaire de cette entreprise ? Son rôle sera changé en Propriétaire si nécessaire.",
  EXISTING_USER_AS_OWNER:
    "Un utilisateur avec cet e-mail existe déjà. Confirmez pour le définir comme propriétaire de cette entreprise.",
  tie_existing_staff_title: "L'utilisateur existe déjà",
  tie_existing_staff_confirm:
    "Un utilisateur avec cet e-mail existe déjà. Voulez-vous changer son rôle ? Son compte existant sera conservé.",
  EXISTING_USER_AS_STAFF:
    "Un utilisateur avec cet e-mail existe déjà. Confirmez pour changer son rôle.",
  USER_ALREADY_HAS_PRACTICE_ROLE:
    "Cet utilisateur a déjà le rôle {role} dans une autre entreprise.",
  no_owner: "(aucun propriétaire)",
  INVALID_COMPANY_OWNER: "Le propriétaire sélectionné doit avoir le rôle Propriétaire.",
  MISSING_COMPANY_DETAILS:
    "Les frais de plateforme sont requis pour créer une entreprise.",
  MISSING_COMPANY:
    "Une entreprise est requise pour les propriétaires, les gestionnaires et les prescripteurs.",
  MISSING_COMPANY_OWNER:
    "Le prénom, le nom et l'e-mail du propriétaire sont requis.",
  CANNOT_EDIT_COMPANY_NAME_OR_OWNER:
    "Le nom de l'entreprise, le pays et les informations du propriétaire ne peuvent pas être modifiés.",
  CANNOT_DELETE_OWNER_WITH_COMPANY:
    "Cet utilisateur ne peut pas être supprimé car il est propriétaire d'une entreprise. Supprimez d'abord l'entreprise.",
  ADMIN_CANNOT_CREATE_PRESCRIBER:
    "Les administrateurs ne peuvent pas créer de prescripteurs. Créez un propriétaire, ou invitez des membres depuis la page équipe.",
  ONLY_OWNER_CAN_EDIT_FEES:
    "Seul le propriétaire du cabinet peut modifier les tarifs.",
  INVALID_TEAM_ROLE:
    "Les membres de l'équipe doivent être invités en tant que Prescripteur ou Gestionnaire.",
  CANNOT_CREATE_ADMIN: "Vous ne pouvez pas créer ni attribuer le rôle Admin.",
  ASSISTANT_CANNOT_MANAGE_ADMIN:
    "Les assistants ne peuvent pas modifier ni supprimer les utilisateurs administrateurs.",
  ACCESS_CONTEXT_ASSISTANT_ONLY:
    "Les Permissions D'Accès ne peuvent être définies que pour les utilisateurs Assistant.",
  access_context: "Permissions D'Accès",
  access_context_select_user: "Sélectionner un assistant",
  access_context_saved: "Permissions D'Accès enregistrées.",
  access_context_module: "Module",
  access_action_read: "Lire",
  access_action_create: "Créer",
  access_action_update: "Modifier",
  access_action_delete: "Supprimer",
  access_module_invitations: "Invitations et questionnaires",
  access_module_reports: "Rapports",
  access_module_observations: "Observations",
  access_module_users: "Utilisateurs",
  access_module_companies: "Entreprises",
  access_module_report_templates: "Modèles de rapport",
  access_module_notification_templates: "Modèles de Notifications Push",
  access_module_email_templates: "Modèles d'e-mail",
  access_module_custom_texts: "Textes personnalisés",
  access_module_editable_values: "Paramètres",
  access_module_editable_values_submenus: "Valeurs éditables",
  access_module_database: "Base de données",
  access_module_database_submenus:
    "Questionnaires, Questions, Options de réponse et Configuration de texte",
  access_module_gallery: "Galerie",
  access_module_main_algorithm: "Algorithme principal",
  access_module_main_algorithm_submenus:
    "Critères, Usage des critères, Méta-compétences, Principes, Config algorithme, Éléments",
  access_module_mobile_apps: "Applications mobiles",
  access_module_mobile_apps_submenus:
    "Liste et par app : Composants, Env, Utilisateurs, Highlights, Historique, Textes statiques, Notifications, Critères",
  access_module_advanced: "Avancé",
  access_module_advanced_submenus:
    "Sentiments, Organes, Saisons, Éléments naturels, Caractères, Entrées, Sorties, Gestion des critères",
  access_desc_invitations_read: "voir l'Historique et les Invitations",
  access_desc_invitations_create: "inviter des Utilisateurs",
  access_desc_invitations_update: "modifier les Réponses et le Prescripteur",
  access_desc_reports_update: "envoyer ou bloquer l'envoi",
  access_desc_users_update: "modifier et suspendre",
  access_desc_companies_update: "modifier et suspendre",
  access_desc_gallery_create: "téléverser des photos",
};

export default messages;
